import React from 'react';
import { Segment, Dimmer, Loader, Input, Pagination, Table, Button } from 'semantic-ui-react';
import api from '../../api';
import Config from '../../constants/Config';
import styles from './Function.module.scss';
import FunctionPopup from '../FunctionPopup/FunctionPopup';

const Function = React.memo(() => {
  const [isLoad, setIsLoad] = React.useState(false);
  const [member, setMember] = React.useState({
    search: '',
    list: [],
    total: 0,
    currentSkip: 1,
  });

  const init = React.useCallback(() => {
    setIsLoad(true);

    api
      .getUserFunctionActions({
        search: member.search,
        limit: Config.AONNOUCEMENT_LIMIT,
        skip: member.currentSkip - 1,
      })
      .then((res) => {
        setMember((prevList) => {
          const newList = { ...prevList };
          newList.list = res.items;
          newList.total = res.total;
          return newList;
        });
      })
      .finally(() => {
        setIsLoad(false);
      });
  }, [member.currentSkip, member.search]);

  const handlePageChange = (e, { activePage }) => {
    setMember((prevList) => {
      const newList = { ...prevList };
      newList.currentSkip = activePage;
      return newList;
    });
  };
  const handleFieldChange = (e, { value }) => {
    setMember((prevList) => {
      const newList = { ...prevList };
      newList.search = value;
      return newList;
    });
  };

  const again = () => {
    setMember((prevList) => {
      const newList = { ...prevList };
      newList.currentSkip = 1;
      return newList;
    });
    init();
  };
  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      again();
    }
  };
  React.useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [member.currentSkip]);

  return (
    <div className={styles.app}>
      <div className={styles.table}>
        <div className={styles.box}>
          <Input
            value={member.search}
            onChange={handleFieldChange}
            action={{
              content: '查找',
              onClick: again,
            }}
            onKeyPress={handleKeyPress}
            placeholder="姓名/用户名搜索"
            className={styles.input}
          />
        </div>
        <Segment>
          <Dimmer active={isLoad} inverted>
            <Loader inverted />
          </Dimmer>
          <Table celled unstackable fixed sortable>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>用户名</Table.HeaderCell>
                <Table.HeaderCell>姓名</Table.HeaderCell>
                <Table.HeaderCell>电话</Table.HeaderCell>
                <Table.HeaderCell>邮箱</Table.HeaderCell>
                <Table.HeaderCell width={2}>操作</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {!!member.list.length &&
                member.list.map((item) => (
                  <Table.Row key={item.id}>
                    <Table.Cell>{item.username}</Table.Cell>
                    <Table.Cell>{item.name}</Table.Cell>
                    <Table.Cell>{item.phone || '-'}</Table.Cell>
                    <Table.Cell>{item.email}</Table.Cell>
                    <Table.Cell>
                      <FunctionPopup id={item.id} functions={item.functionActions} onUpdate={again}>
                        <Button>开放功能</Button>
                      </FunctionPopup>
                    </Table.Cell>
                  </Table.Row>
                ))}
            </Table.Body>
            <Table.Footer>
              <Table.Row>
                <Table.HeaderCell colSpan="5" style={{ textAlign: 'right' }}>
                  <Pagination
                    activePage={member.currentSkip}
                    totalPages={member.total}
                    onPageChange={handlePageChange}
                  />
                </Table.HeaderCell>
              </Table.Row>
            </Table.Footer>
          </Table>
        </Segment>
      </div>
    </div>
  );
});

export default Function;
